import service from './RestService';
import { RestResponse } from '../types/response/RestResponse';
import { ContactPersonSearch, Project, ProjectStatus, SubcontractorAccount } from '../state/project/types';
import BookingProjectSettings from '../types/model/BookingProjectSettings';
import { InternalUser } from '../state/users/types';
import { UserRoleType } from '../state/user/types';

const path = '/projects';

class ProjectsService {
  getProjects = (active: boolean): RestResponse<Project[]> => service.get(`${path}${active ? '?status=Active' : ''}`);

  getContactPerson = (projectId: number, searchTerms: string): RestResponse<ContactPersonSearch> =>
    service.get(`${path}/${projectId}/contact-person-search`, { searchTerms });

  getSettings = (projectId: number): RestResponse<BookingProjectSettings> => service.get(`booking/project/${projectId}`);

  getInternalUserProjects = (userId: number): RestResponse<Project[]> => service.get(`${path}/users`, { userId });

  getExternalUserProjects = (userId: number): RestResponse<Project[]> => service.get(`${path}/subcontractors/${userId}`);

  changeProjectStatus = (projectId: number, status: ProjectStatus): RestResponse<null> => service.put(`${path}/${projectId}/status`, { status });

  getInternalUsersByProjectId = (projectId: number): RestResponse<InternalUser[]> => service.get(`${path}/${projectId}/internal-users`);

  setInternalUserRole = (projectID: number, userID: number, role: UserRoleType): RestResponse<null> =>
    service.post(`${path}/${projectID}/internal-users/assign-role`, { userID, role });

  removeInternalUserRole = (projectId: number, userId: number): RestResponse<null> =>
    service.post(`${path}/${projectId}/internal-users/remove-role?userId=${userId}`);

  validateSubcontractorAccount = (projectId: number, subcontractorEmail: string, isAssigned: boolean): RestResponse<SubcontractorAccount> =>
    service.get(`${path}/${projectId}/subcontractors`, { subcontractorEmail, isAssigned });

  sendLoginData = (projectId: number, subcontractorId: number): RestResponse<null> =>
    service.post(`${path}/${projectId}/subcontractors/${subcontractorId}/send-invite`);

  addSubcontractorToProject = (
    projectId: number,
    subcontractorId: number,
    notificationsEmail: string,
    notificationsContactName: string
  ): RestResponse<null> => service.post(`${path}/${projectId}/subcontractors`, { subcontractorId, notificationsEmail, notificationsContactName });
}
export default new ProjectsService();
